import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { apiAssessors } from 'helpers/decorators/api'
import { meta, permissions } from 'helpers/decorators'
import { Section, Title } from '../../../components/layout'
import { Button, ButtonGroup, Status } from '../../../components/misc'
import { File } from '../../misc'
import { connect } from 'react-redux'
import { Data, Table } from '../../../components/layout/Table'
import { assessorFiles as filesLayout } from '../../../constants/layout'
import { FormattedDate } from '../../../components/intl'
import { get } from 'lodash'
import AssessorFileDetailModal from '../../../components/modals/assessors/AssessorFileDetailModal'
import { getActivityName, getCategoryName, getSection } from '../../../helpers/assessorHelper'


@meta({
  title: 'Assessors',
  intlKey: 'route.assessors'
})
@permissions()
@apiAssessors({ loadFiles: true })
@connect(
    ({ api }) => ({
        files: api.assessors.files.list || [],
        loading: api.assessors.files.loading,
        assessor: api.assessors.detail
    }),
    {}
)
class AssessorFiles extends Component {
  static propTypes = {
    files: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    assessor: PropTypes.object.isRequired
  }

  state = {
      fileDetail: null,
      assessor: null
  }

    handleDisplayDetail = file => {
        this.setState(
            {
                fileDetail: file
            },
            () => {
                this.props.modal(`display-assessor-file-${this.key}`)
            }
        )
    }


  render() {
        const { files, loading } = this.props

        return (
            <div>
            <Section>
                <div className="text--right">
                </div>
                <div className="base-margin--top">
                    <Title h2 intlKey="moduleTitle.files">
                        Files
                    </Title>
                    <Table
                        ths={filesLayout.tableHeaders}
                        length={files.length}
                        loading={loading}
                    >
                        <Data>
                            {files.map((item) => (
                                <tr key={get(item, 'id')}>
                                    <td>
                                        {get(item, 'fileUrl') &&
                                        <File
                                            src={get(item, 'fileUrl')}
                                            title={get(item, 'title')}
                                            clickable={true}
                                            withAuthCode
                                        />}
                                    </td>
                                    <td>
                                        {get(item, 'title')}
                                    </td>
                                    <td>
                                        {get(item, 'description')}
                                    </td>
                                    <td>
                                        {get(item, 'createdAt') && <FormattedDate value={get(item, 'createdAt')} />}
                                    </td>
                                    <td>
                                        {getSection(item)}<br />
                                        {getActivityName(item)}<br />
                                        {getCategoryName(item)}<br />
                                    </td>
                                    <td>
                                        <Status state={get(item, 'isWWC')} check noWaiting />
                                    </td>
                                    <td>
                                        <ButtonGroup>
                                            <Button
                                                tiny
                                                type="button"
                                                intlKey="button.view_more"
                                                onClick={() => this.handleDisplayDetail(item)}
                                            >
                                                View more
                                            </Button>
                                        </ButtonGroup>
                                    </td>
                                </tr>
                            ))}
                        </Data>
                    </Table>
                </div>

            </Section>
                <AssessorFileDetailModal
                    modalId={`display-assessor-file-${this.key}`}
                    data={this.state.fileDetail}
                    assessor={this.props.assessor}
                />
            </div>
        )
    }
}

export default AssessorFiles
